import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const ScopesList = ({
  scopes
}) => {
  return /*#__PURE__*/_jsx(Flex, {
    display: "inline-flex",
    flexDirection: "row",
    as: "ol",
    flexWrap: "wrap",
    children: scopes.map(scope => /*#__PURE__*/_jsx(View, {
      as: "li",
      padding: "100",
      display: "inline-block",
      children: /*#__PURE__*/_jsx(View, {
        backgroundColor: "fill-field-default",
        borderWidth: "100",
        borderColor: "border-core-subtle",
        borderStyle: "solid",
        paddingInlineStart: "100",
        paddingInlineEnd: "100",
        children: /*#__PURE__*/_jsx(Text, {
          as: "code",
          typography: "code-100",
          children: scope
        })
      })
    }, scope))
  });
};
export default ScopesList;